module.exports = __webpack_public_path__ + "static/media/famiglia1.d5520f62.jpeg";